export enum DocumentSortOrderEnum {
  ASC = 'asc',
  DESC = 'desc',
  DEFAULT = 'default'
}

export enum DocumentSortValueEnum {
  DATE = 'date',
  TITLE = 'title',
  DEFAULT = 'default'
}

export enum DocumentSortOptionsEnum {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  ATOZ = 'ATOZ',
  ZTOA = 'ZTOA',
  DEFAULT = 'DEFAULT'
}
// File renamed to src/features/documents/types/types.ts
